import { render, staticRenderFns } from "./GuestbookTestPage.vue?vue&type=template&id=7a5f6bad&scoped=true"
import script from "./GuestbookTestPage.vue?vue&type=script&lang=js"
export * from "./GuestbookTestPage.vue?vue&type=script&lang=js"
import style0 from "./GuestbookTestPage.vue?vue&type=style&index=0&id=7a5f6bad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5f6bad",
  null
  
)

export default component.exports